<template>
  <v-layout row wrap>
    <v-flex xs2>
      <v-checkbox label="Visa" v-model="visa" disabled></v-checkbox>
    </v-flex>
    <v-flex xs2>
      <v-checkbox label="Visa Electron" v-model="visaElectron" disabled></v-checkbox>
    </v-flex>
    <v-flex xs2>
      <v-checkbox label="MasterCard" v-model="mastercard" disabled></v-checkbox>
    </v-flex>
    <v-flex xs2>
      <v-checkbox label="Maestro" v-model="maestro" disabled></v-checkbox>
    </v-flex>
    <v-flex xs2>
      <v-checkbox label="JCB" v-model="jcb" disabled></v-checkbox>
    </v-flex>
    <v-flex xs2>
      <v-checkbox label="Diners" v-model="diners" disabled></v-checkbox>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderDetailCardBrands',
  computed: {
    visa: {
      get () { return this.$store.state.order.visaEnabled },
      set (value) { this.$store.commit('updateOrder', ['visaEnabled', value]) }
    },
    visaElectron: {
      get () { return this.$store.state.order.visaElectronEnabled },
      set (value) { this.$store.commit('updateOrder', ['visaElectronEnabled', value]) }
    },
    mastercard: {
      get () { return this.$store.state.order.mastercardEnabled },
      set (value) { this.$store.commit('updateOrder', ['mastercardEnabled', value]) }
    },
    maestro: {
      get () { return this.$store.state.order.maestroEnabled },
      set (value) { this.$store.commit('updateOrder', ['maestroEnabled', value]) }
    },
    jcb: {
      get () { return this.$store.state.order.jcbEnabled },
      set (value) { this.$store.commit('updateOrder', ['jcbEnabled', value]) }
    },
    diners: {
      get () { return this.$store.state.order.dinersEnabled },
      set (value) { this.$store.commit('updateOrder', ['dinersEnabled', value]) }
    }
  }
}
</script>

<style scoped>

</style>
